import type { PartDefinition } from "@rogue/rackbuilder"
import { THREE_TIER_DUMBBELL } from "../../modelPaths"

export class ThreeTierDumbbellBuilder {
  public build(): PartDefinition {
    const shelf: PartDefinition = {
      mesh  : `${THREE_TIER_DUMBBELL}#shelf`,
      slots : {},
    }

    // Add the dumbbell cradles
    for (let i = 1; i < 11; i += 1) {
      shelf.slots[`db${i}`] = { mesh: `${THREE_TIER_DUMBBELL}#db cradle`, slots: {} }
    }

    return {
      mesh  : `${THREE_TIER_DUMBBELL}#left`,
      slots : {
        otherside : { mesh: `${THREE_TIER_DUMBBELL}#right`, slots: {} },
        shelf1    : JSON.parse(JSON.stringify(shelf)),
        shelf2    : JSON.parse(JSON.stringify(shelf)),
        shelf3    : JSON.parse(JSON.stringify(shelf)),
      },
    }
  }
}
